import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Search from '@/components/Search/Search'
import ThankYou from '@/components/ThankYou'
import Sentenza from '@/components/Sentenza/Sentenza'
import Privacy from '@/components/Privacy/Privacy'
import OAuth from '@/components/OAuth'
import Utente from '@/components/Utente/Utente'
import Profilo from '@/components/Utente/Profilo'
import ModificaProfilo from '@/components/Utente/ModificaProfilo'
import Pagamento from '@/components/Pagamento/Pagamento'
import InfoPagamento from '@/components/Pagamento/InfoPagamento'
import Newsletter from '@/components/Newsletter/Newsletter'
import Logout from '@/components/Logout'
import Attivazione from '@/components/Attivazione'

import GestioneUtenti from '@/components/Admin/GestioneUtenti'
import AdminNewsletter from '@/components/Admin/Newsletter'
import SocialSentenze from '@/components/Admin/SocialSentenze'
import ModificaUtente from '@/components/Admin/ModificaUtente'

import Massima from '@/components/Pubblica/Massima'
import RicercaMassime from '@/components/Pubblica/Ricerca'
import NewsletterMassime from '@/components/Pubblica/Newsletter'
import UltimeMassime from '@/components/Pubblica/UltimeMassime'
import { faHome } from '@fortawesome/free-solid-svg-icons'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    //TODO: figure out why Home.vue doesn't render
    //FIXME: change it to Home component
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: 'GiustUp'
      }
    },
    {
      path: '/',
      name: 'ThankYou',
      component: ThankYou,
      meta: {
        title: 'GiustUp'
      }
    },
    {
      path: '/oauth',
      name: 'Oauth',
      component: OAuth
    },
    {
      path: '/attivazione',
      name: 'Attivazione',
      component: Attivazione
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        auth: true,
        title: 'GiustUp - Ricerca sentenze'
      }
    },
    {
      path: '/sentenza/:idNodo',
      name: 'Sentenza',
      component: Sentenza,
      meta: {
        auth: true,
        title: 'GiustUp - Visualizza sentenza'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        auth: true,
        title: 'GiustUp - Privacy'
      }
    },
    {
      path: '/utente',
      name: 'Utente',
      component: Utente,
      meta: {
        auth: true,
        title: 'GiustUp - Profilo utente'
      }
    },
    {
      path: '/profilo/:codFisc',
      name: 'Profilo',
      component: Profilo,
      meta: {
        auth: true,
        title: 'GiustUp - Profilo utente'
      }
    },
    {
      path: '/modificaprofilo',
      name: 'ModificaProfilo',
      component: ModificaProfilo,
      meta: {
        auth: true,
        title: 'GiustUp - Modifica profilo utente'
      }
    },
    {
      path: '/pagamento',
      name: 'Pagamento',
      component: Pagamento,
      meta: {
        auth: true,
        title: 'GiustUp - Pagamento'
      }
    },
    {
      path: '/pagamentoinfo/:tipopagamento',
      name: 'InfoPagamento',
      component: InfoPagamento,
      meta: {
        auth: true,
        title: 'GiustUp - Pagamento'
      }
    },
    {
      path: '/newsletter',
      name: 'Newsletter',
      component: Newsletter,
      meta: {
        auth: true,
        title: 'GiustUp - Newsletter'
      }
    },
    {
      path: '/admin/utenti',
      name: 'GestioneUtenti',
      component: GestioneUtenti,
      meta: {
        auth: true,
        title: 'GiustUp - Gestione Utenti'
      }
    },
    {
      path: '/admin/newsletter',
      name: 'AdminNewsletter',
      component: AdminNewsletter,
      meta: {
        auth: true, 
        title: 'GiustUp - Admin newsletter'
      }
    },
    {
      path: '/admin/sentenze',
      name: 'SocialSentenze',
      component: SocialSentenze,
      meta: {
        auth: true,
        title: 'GiustUp - Gestione sentenze'
      }
    },
    {
      path: '/admin/utenti/:userId',
      name: 'ModificaUtente',
      component: ModificaUtente,
      meta: {
        auth: true,
        title: 'GiustUp - Modifica Utente'
      }
    },
    {
      path: '/massima/:idMassima',
      name: 'Massima',
      component: Massima,
      meta: {
        auth: false,
        title: 'GiustUp - Massima'
      }
    },
    {
      path: '/massime',
      name: 'RicercaMassime',
      component: RicercaMassime,
      meta: {
        auth: false,
        title: 'GiustUp - Ricerca massime'
      }
    },
    {
      path: '/newslettermassime',
      name: 'NewsletterMassime',
      component: NewsletterMassime,
      meta: {
        auth: false,
        title: 'GiustUp - Newsletter massime'
      }
    },
    {
      path: '/ultimemassime',
      name: 'UltimeMassime',
      component: UltimeMassime,
      meta: {
        auth: false,
        title: 'GiustUp - Ultime massime inserite'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      let y = 0;
      if(to.name === "Search" && from.name === "Sentenza" && to.params.scrollY)
        y = to.params.scrollY;
      return { x: 0, y: y };
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js